<template>
  <div>
    <a-spin :spinning="loading">
      <div class="row">
        <div class="col-12 col-md-3">
          <!-- Student List -->
          <template v-if="data.length">
            <p class="mb-0 font-weight-bold mb-1">Students</p>
            <a-divider />
            <p
              v-for="student in data"
              :key="student.enrollment[0].id"
            >
              <a
                :class="[`${selectedStudentId === student.enrollment[0].id ? 'text-primary' : ''}`]"
                href="javascript:0;"
                @click="handleStudentSelect(student.enrollment[0].id, student)"
              >
              ({{student.student_code}}) {{student.first_name}} {{student.last_name}}
              </a>
            </p>
          </template>
          <template v-if="!data.length">
            <NoData text="No students found" />
          </template>
        </div>
        <div class="col-md-9">
          <div class="mb-2">
            <a-collapse :bordered="false">
              <template v-slot:expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel header="Show Report Filters" key="1" :style="customCollapseStyle">
              <p class="font-weight-bold text-muted">Select what you would like to include in the report!</p>
                <div class="row mb-3">
                  <div class="col-4 col-md-3" v-for="reportOption in reportViewOptions" :key="reportOption.value">
                    <a-checkbox v-model="options[reportOption.value]" >
                      {{reportOption.label}}
                    </a-checkbox>
                  </div>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </div>
          <div class="my-3 p-3 border" v-if="studentData">
            <reports-view :student="selectedStudent" :data="studentData" :options="options"/>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import NoData from '@/components/layout/NoData/index'

import ReportsView from '@/components/student/Report/partials/ReportsView'

const reportViewOptions = [
  { label: 'Student Contact', value: 'showContact' },
  { label: 'Academic Info', value: 'showAcademicInfo' },
  { label: 'Medical Info', value: 'showMedicalInfo' },
  { label: 'Previous School Info', value: 'showPreviousSchoolInfo' },
  { label: 'Parent Info', value: 'showParentsInfo' },
  { label: 'Parent Contact Info', value: 'showParentsContactInfo' },
  { label: 'Attendance Info', value: 'showAttendanceInfo' },
  { label: 'Fee Info', value: 'showFeeInfo' },
  // { label: 'Exam Info', value: 'showExamInfo' },
]

export default {
  name: 'StudentsReports',
  components: {
    NoData,
    ReportsView,
  },
  props: ['data'],
  data: function() {
    return {
      reportViewOptions,
      loading: false,
      selectedStudentId: undefined,
      selectedStudent: {},
      studentData: null,
      options: {
        showContact: true,
        showAcademicInfo: true,
        showMedicalInfo: true,
        showPreviousSchoolInfo: false,
        showParentsInfo: true,
        showParentsContactInfo: false,
        showAttendanceInfo: true,
        showFeeInfo: false,
        showExamInfo: false,
      },
      customCollapseStyle:
          'background: #f7f7f7;border-radius: 4px;border: 0;overflow: hidden',
    }
  },
  watch: {
    data: function(value) {
      if (value && value.length) {
        this.selectedStudentId = value[0].enrollment[0].id
        this.selectedStudent = value[0]
      } else {
        this.selectedStudentId = null
        this.studentData = null
      }
    },
  },
  methods: {
    handleStudentSelect(studentId, student) {
      this.studentData = null
      if (studentId) {
        this.loading = true
        this.$http.get('/api/reports/student/' + studentId)
          .then(({ data }) => {
            this.loading = false
            this.studentData = data.data
            this.selectedStudentId = studentId
            this.selectedStudent = student
          })
      }
    },
    selectChange() {
      console.log(this.options)
    },
  },
}
</script>
